import { ACCOUNTS_NIB_IBAN } from '@/assets/constants/masks'
import { amountFormat } from '@/assets/scripts/amounts'
import { ibanFormat, accountFormatHelper } from '@/assets/scripts/strings'
import { useI18n } from 'vue-i18n'

export const getSpecificTextBlocksData = operation => {
	const { t } = useI18n()

    switch (operation.operationTypeId) {
    case 74:
    case 75:
        return [
            { label: t('approvals.operationBlock.beneficiaryNameLabel'), content: operation.beneficiaryName },
            {
                label: operation.operationTypeId === 74 ? t('approvals.operationBlock.destinationAccountIbanLabel') : t('approvals.operationBlock.destinationIban'),
                content: operation.destinationAccountDescription ? (operation.destinationAccountDescription.length === 14 ? accountFormatHelper(operation.destinationAccountDescription) : ibanFormat(operation.destinationAccountDescription)) : operation.destinationAccountDescription
            },
            {
                label: t('approvals.operationBlock.descriptionLabel'),
                content: operation.description ? operation.description : '-',
                showInMobile: true
            }
        ]

    case 2006:
        return [
            { label: t('approvals.operationBlock.solicitationType'), content: operation.solicitationType },
            { label: t('approvals.operationBlock.tpaQuantity'), content: operation.quantity },
            {
                label: t('approvals.operationBlock.establishmentName'),
                content: operation.establishmentName,
                showInMobile: true
            }
        ]

    case 21002:
    case 22028:
    case 22031:
    case 19001:
    case 19002:
    case 19003:
    case 19004:
    case 31002:
    case 31104:
    case 31106:
    case 35002:
    case 35004:
    case 35008:
    case 35018:
    case 35201:
    case 35021: // payments
        return [
            {
                label: t('approvals.operationBlock.operatorLabel'),
                content: operation.operationDescription,
                showInMobile: true
            },
            { label: t('approvals.operationBlock.initiatorContractNameLabel'), content: operation.initiatorContractName },
            { label: t('approvals.operationBlock.channelLabel'), content: operation.channel }
        ]

    case 32009: // smartTransfers
        return [
            {
                label: t('approvals.operationBlock.beneficiaryNameLabel'),
                content: operation.beneficiaryName ? operation.beneficiaryName : '-'
            },
            { label: t('approvals.operationBlock.destinationPhoneNumberLabel'), content: operation.destinationMsisdn },
            {
                label: t('approvals.operationBlock.descriptionLabel'),
                content: operation.description ? operation.description : '-',
                showInMobile: true
            }
        ]

    case 5000: // charge flex
        return [
            {
                label: t('approvals.operationBlock.destinationCardLabel'),
                content: operation.codedCardNumber,
                showInMobile: true
            },
            { label: t('approvals.operationBlock.initiatorContractNameLabel'), content: operation.initiatorContractName },
            { label: t('approvals.operationBlock.channelLabel'), content: operation.channel }
        ]

    case 5037:
        return [
            { label: t('approvals.operationBlock.solicitationType'), content: operation.cardType },
            { label: t('approvals.operationBlock.initiatorContractNameLabel'), content: operation.initiatorContractName },
            {
                label: t('approvals.operationBlock.branchNamelabel'),
                content: operation.branchName ? operation.branchName : '-',
                showInMobile: true
            }
        ]

    // comment while we can't test this, making this go to default case
    // case 19102: // cardless withdraw
    // 	return [
    // 		{ label: t('approvals.operationBlock.originCardLabel'), value: 'falta dados para testar' },
    // 		{ label: t('approvals.operationBlock.destinationMsisdnLabel'), value: 'falta dados para testar' },
    // 		{ label: t('approvals.operationBlock.channelLabel'), value: operation.channel }
    // 	]

    case 40: // create DP
    case 41: // charge DP
        return [
            {
                label: t('approvals.operationBlock.productLabel'),
                content: operation.termAccountProduct,
                showInMobile: true
            },
            { label: t('approvals.operationBlock.durationLabel'), content: `${operation.duration} ${t('approvals.operationBlock.daysLabel')}` },
            {
                label: t('approvals.operationBlock.initiatorContractNameLabel'),
                content: operation.initiatorContractName
            }
        ]

    case 106: // cancel IP
        return [
            {
                label: t('approvals.operationBlock.destinationAccountIbanLabel'),
                content: operation.originAccountDescription,
                mask: ACCOUNTS_NIB_IBAN,
                showInMobile: true
            },
            { label: t('approvals.operationBlock.initiatorContractNameLabel'), content: operation.initiatorContractName },
            { label: t('approvals.operationBlock.channelLabel'), content: operation.channel }
        ]

    case 107: // create IP
        return [
            {
                label: t('approvals.operationBlock.beneficiaryNameLabel'),
                content: operation.beneficiaryName ? operation.beneficiaryName : '-',
                showInMobile: true
            },
            {
                label: t('approvals.operationBlock.destinationAccountIbanLabel'),
                content: operation.genericDestination,
                mask: ACCOUNTS_NIB_IBAN
            },
            { label: t('approvals.operationBlock.periodicityLabel'), content: operation.periodicity }
        ]

    case 1092: // edit IP
        return [
            {
                label: t('approvals.operationBlock.beneficiaryNameLabel'),
                content: operation.beneficiaryName ? operation.beneficiaryName : '-'
            },
            {
                label: t('approvals.operationBlock.editedByLabel'),
                content: operation.initiatorContractName
            },
            {
                label: t('approvals.operationBlock.descriptionDebitLabel'),
                content: operation.descriptionDebit,
                showInMobile: true
            }
        ]
    case 501: // Create Operator
        return [
            {
                label: t('approvals.operationBlock.createdByLabel'),
                content: operation.initiatorContractName,
                showInMobile: true
            },
            { label: t('approvals.operationBlock.channelLabel'), content: operation.channel }
        ]
    case 504: // Delete Operator
        return [
            {
                label: t('approvals.operationBlock.accessionNumberLabel'),
                content: operation.operatorUsername,
                showInMobile: true
            },
            {
                label: t('approvals.operationBlock.deletedByLabel'),
                content: operation.initiatorContractName
            },
            { label: t('approvals.operationBlock.channelLabel'), content: operation.channel }
        ]
    case 503: // Edit Operator
        return [
            {
                label: t('approvals.operationBlock.accessionNumberLabel'),
                content: operation.operatorUsername,
                showInMobile: true
            },
            {
                label: operation.currentOperatorStatus === 4 && operation.futureOperatorStatus === 3 ? t('approvals.operationBlock.unblockedByLabel') : t('approvals.operationBlock.editedByLabel'),
                content: operation.initiatorContractName
            },
            { label: t('approvals.operationBlock.channelLabel'), content: operation.channel }
        ]
    /* IPOs */
    case 18003: /* Submit Offer */
    case 18004: /* Edit Offer */
    case 18005: /* Delete Offer */
        return [
            {
                label: t('approvals.operationBlock.beneficiaryNameLabel'),
                content: operation.beneficiaryName || '-',
                showInMobile: true
            },
            { label: t('approvals.operationBlock.sharesQuantity'), content: operation.totalShareAmount || '-' },
            {
                label: t('approvals.operationBlock.unityAmount'),
                content: operation.totalOfferPrice ? amountFormat(operation.totalOfferPrice, operation.originAccountCurrency) : '-'
            }
        ]
    /* Custodia Account creation */
    case 18008:
        return [
            {
                label: t('approvals.operationBlock.accountType'),
                content: operation.accountType,
                showInMobile: true
            },
            { label: t('approvals.operationBlock.initiatorContractNameLabel'), content: operation.initiatorContractName },
            { label: t('approvals.operationBlock.channelLabel'), content: operation.channel }
        ]
    /* Sell Orders */
    case 18122: /* Submit Sell Order */
    case 18123: /* Delete Sell Order */
    case 18125: /* Edit Sell Order */
        return [
            {
                label: t('approvals.operationBlock.instrumentNameLabel'),
                content: operation.instrumentName || '-',
                showInMobile: true
            },
            { label: t('approvals.operationBlock.sharesQuantity'), content: operation.shareQuantity || '-' },
            {
                label: t('approvals.operationBlock.unityShareAmount'),
                content: operation.proposalPrice ? amountFormat(operation.proposalPrice, operation.originAccountCurrency) : '-'
            }
        ]
    /* Buy Orders */
    case 18126: /* Submit Buy Offer */
    case 18129: /* Edit Buy Offer */
    case 18132: /* Cancel Buy Order */
        return [
            {
                label: t('approvals.operationBlock.instrumentNameLabel'),
                content: operation.instrumentName || '-',
                showInMobile: true
            },
            { label: t('approvals.operationBlock.sharesQuantity'), content: operation.shareQuantity || '-' },
            {
                label: t('approvals.operationBlock.unityBuyShareAmount'),
                content: operation.proposalPrice ? amountFormat(operation.proposalPrice, operation.originAccountCurrency) : '-'
            }
        ]
    case 500001: /* Batchfile Charge Cards */
        return [
            {
                label: t('approvals.operationBlock.cardType'),
                content: operation.cardTypeGroup || '-',
                showInMobile: true
            },
            { label: t('approvals.operationBlock.numberOfRecords'), content: operation.numberOfRecords || '-' },
            {
                label: t('approvals.operationBlock.sourceReference'),
                content: operation.topupPrepaidCreditCardBatchFileSubmission ? (operation.topupPrepaidCreditCardBatchFileSubmission.sourceReference || '-') : '-'
            }
        ]
    case 25003: /* Adianta ja */
        return [
            { label: t('approvals.operationBlock.initiatorContractNameLabel'), content: operation.initiatorContractName },
            { label: t('approvals.operationBlock.channelLabel'), content: operation.channel },
            {
                label: t('approvals.operationBlock.descriptionLabel'),
                content: operation.operationDescription ? operation.operationDescription : '-',
                showInMobile: true
            }
        ]
    case 501003: /* Subscrição seguro viagem */
        return [
            {
                label: t('approvals.operationBlock.policyType'),
                content: operation.insuranceDescription,
                showInMobile: true
            },
            { label: t('approvals.operationBlock.insurancePersons'), content: operation.insuredPersonsNumber },
            {
                label: t('approvals.operationBlock.totalPremium'),
                content: operation.amount ? amountFormat(operation.amount.amount, operation.amount.currency) : '-'
            }
        ]
    case 4000005: /* OPE Empresa */
        return [
            {
                label: t('approvals.operationBlock.transferType'),
                content: operation.paymentType,
                showInMobile: true
            },
            {
                label: t('approvals.operationBlock.opeEstimatedAmount'),
                content: operation.amount ? amountFormat(operation.estimatedValue, operation.originAccountCurrency) : '-'
            }
        ]
    default:
        return [
            { label: t('approvals.operationBlock.initiatorContractNameLabel'), content: operation.initiatorContractName },
            { label: t('approvals.operationBlock.channelLabel'), content: operation.channel },
            {
                label: t('approvals.operationBlock.descriptionLabel'),
                content: operation.description ? operation.description : operation.operationDescription ? operation.operationDescription : '-',
                showInMobile: true
            }
        ]
    }
}
